module.exports = __webpack_public_path__ + "static/media/iFlyThere.45c78410.jpg";